import { createElement } from "@max/max";
import { Skeleton } from '@nibfe/marketing-blocks-universal';
import View from '@hfe/max-view';
import { threeSkBlock } from '../../utils/constant';
import './index.scss';
export const SkeletonS = (props) => {
    const { skeletonData, type, count } = props;
    if (skeletonData && type === 'double') {
        return <View style={{
            backgroundColor: '#F4F4F4',
            overflow: 'hidden'
        }}>
                <View style={{
            marginTop: '-40rpx'
        }}>
                    <Skeleton width={'750rpx'} height={'1200rpx'} skeletonData={skeletonData}/>
                </View>
            </View>;
    }
    return <View className="skeleton-container-view">
        {Array.from({
        length: count
    }).map(() => <>
            <View className="skeleton-container-item">
                <View className="skeleton-container">
                    {threeSkBlock.map(({ w, h, t, l, brtl, brtr, brbl, brbr }) => <View className="skeleton-column" style={{
        width: `${w}rpx`,
        height: `${h}rpx`,
        top: `${t}rpx`,
        left: `${l}rpx`,
        borderTopLeftRadius: `${brtl}rpx`,
        borderTopRightRadius: `${brtr}rpx`,
        borderBottomLeftRadius: `${brbl}rpx`,
        borderBottomRightRadius: `${brbr}rpx`
    }}/>)}
                </View>
            </View>
        </>)}
    </View>;
};
